export default __webpack_public_path__ + "static/media/Tribaldick.20f03826.png";